import React, { useState } from "react";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Employee/SubHeader";
import "./AdminMyteam.css";
import { useNavigate } from "react-router-dom";

function AdminMyTeam() {
  const [employees, setEmployees] = useState([
    {
      id: 1,
      name: "John Doe",
      email: "john.doe@example.com",
      position: "Software Engineer",
      image: "https://i.pravatar.cc/40?img=1",
    },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane.smith@example.com",
      position: "Project Manager",
      image: "https://i.pravatar.cc/40?img=2",
    },
    {
      id: 3,
      name: "Mark Johnson",
      email: "mark.johnson@example.com",
      position: "UI/UX Designer",
      image: "https://i.pravatar.cc/40?img=3",
    },
    {
      id: 4,
      name: "Emily Davis",
      email: "emily.davis@example.com",
      position: "HR Specialist",
      image: "https://i.pravatar.cc/40?img=4",
    },
    {
      id: 5,
      name: "Michael Brown",
      email: "michael.brown@example.com",
      position: "QA Tester",
      image: "https://i.pravatar.cc/40?img=5",
    },
    {
      id: 6,
      name: "Sarah Wilson",
      email: "sarah.wilson@example.com",
      position: "Frontend Developer",
      image: "https://i.pravatar.cc/40?img=6",
    },
    {
      id: 7,
      name: "David Lee",
      email: "david.lee@example.com",
      position: "Backend Developer",
      image: "https://i.pravatar.cc/40?img=7",
    },
    {
      id: 8,
      name: "Laura Martinez",
      email: "laura.martinez@example.com",
      position: "Product Owner",
      image: "https://i.pravatar.cc/40?img=8",
    },
    {
      id: 9,
      name: "James Anderson",
      email: "james.anderson@example.com",
      position: "Business Analyst",
      image: "https://i.pravatar.cc/40?img=9",
    },
    {
      id: 10,
      name: "Olivia Taylor",
      email: "olivia.taylor@example.com",
      position: "Tech Lead",
      image: "https://i.pravatar.cc/40?img=10",
    },
  ]);

  const [searchTerm, setSearchTerm] = useState("");
  const [groups, setGroups] = useState([]);
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [newGroupName, setNewGroupName] = useState("");
  const [selectedMembers, setSelectedMembers] = useState([]);

  // ✅ Add User Form State
  const [newUser, setNewUser] = useState({
    firstName: "",
    lastName: "",
    Address: "",
    ContactNumber: "",
    Gender: "",
    EmploymentStatus: "",
    DateHired: "",
    RegularizationDate: "",
    position: "",
  });

  // ✅ Filter employees by search
  const filteredEmployees = employees.filter(
    (employee) =>
      employee.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.position.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ✅ Handle member selection
  const toggleMember = (id) => {
    setSelectedMembers((prev) =>
      prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]
    );
  };

  const handleSaveGroup = () => {
    if (!newGroupName.trim()) return alert("Please enter a group name!");
    if (selectedMembers.length === 0)
      return alert("Please select at least one member!");

    const newGroup = {
      name: newGroupName,
      members: selectedMembers,
    };

    // ✅ Save group to state
    setGroups((prev) => [...prev, newGroup]);

    // Reset modal
    setIsGroupModalOpen(false);
    setNewGroupName("");
    setSelectedMembers([]);

    alert("✅ Group created successfully!");
  };

  // ✅ Add new user
  const handleAddUser = (e) => {
    e.preventDefault();
    const { firstName, lastName, email, position } = newUser;
    if (!firstName || !lastName || !email || !position) {
      alert("Please fill out all required fields.");
      return;
    }

    const newEmployee = {
      id: employees.length + 1,
      name: `${firstName} ${lastName}`,
      email,
      position,
      image: `https://i.pravatar.cc/40?u=${email}`,
      sss: newUser.sss,
      philhealth: newUser.philhealth,
      pagibig: newUser.pagibig,
    };

    setEmployees([...employees, newEmployee]);
    setIsAddUserModalOpen(false);
    setNewUser({
      firstName: "",
      lastName: "",
      email: "",
      position: "",
      sss: "",
      philhealth: "",
      pagibig: "",
    });
  };

  // ✅ Get employees not yet assigned to any group
  const assignedMemberIds = groups.flatMap((g) => g.members);
  const ungroupedEmployees = filteredEmployees.filter(
    (emp) => !assignedMemberIds.includes(emp.id)
  );

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const navigate = useNavigate();

  const [isTransitioning, setIsTransitioning] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [editedEmployee, setEditedEmployee] = useState(null);
  const [deactivatedEmployees, setDeactivatedEmployees] = useState([]);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [employeeToToggle, setEmployeeToToggle] = useState(null);

  const handleSelectEmployee = (employee) => {
    setSelectedEmployee(employee);
    setEditedEmployee(employee); // initialize for editing
    setIsEditing(false);
  };

  const handleSave = () => {
    setEmployees((prev) =>
      prev.map((emp) => (emp.id === editedEmployee.id ? editedEmployee : emp))
    );
    setSelectedEmployee(editedEmployee);
    setIsEditing(false);
  };

  const handleEditRedirect = (employee) => {
    navigate("/AddUser", { state: { employee } });
  };

  const handleDeactivateEmployee = (employeeId) => {
    setDeactivatedEmployees((prev) =>
      prev.includes(employeeId)
        ? prev.filter((id) => id !== employeeId)
        : [...prev, employeeId]
    );

    setSelectedEmployee(null);
  };

  return (
    <div className="myTeamBg">
      <Header />
      <SubHeader />

      <div className="team-container" style={{ padding: "20px" }}>
        {/* Header Section */}
        <div className="MyteamHeader"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <h2 style={{ margin: 0 }}>
            My Team{" "}
            <span style={{ fontWeight: "normal", color: "#666" }}>
              ({filteredEmployees.length})
            </span>
          </h2>

          <div className="SearchAddGroup" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {/* Search Bar */}
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                width: "250px",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            >
              <input
                type="text"
                placeholder="Search employee..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 35px 8px 10px",
                  border: "none",
                  outline: "none",
                  backgroundColor: "transparent",
                }}
              />
              <i
                className="fa fa-search"
                style={{
                  position: "absolute",
                  right: "10px",
                  color: "#555",
                  fontSize: "14px",
                }}
              ></i>
            </div>

            <button
              onClick={() => {
                setIsTransitioning(true);
                setTimeout(() => navigate("/AddUser"), 800); // waits for fade animation
              }}
              className={`add-user-btn ${isTransitioning ? "fade-out" : ""}`}
            >
              + Add User
            </button>

            <button
              onClick={() => setIsGroupModalOpen(true)}
              className="create-group-btn"
            >
              + Create Group
            </button>
          </div>
        </div>

        {/* Grouped Employees */}
        {/* ✅ Departments */}
        {groups.map((group, index) => (
          <div key={index} className="group-section">
            <h3>
              {group.name}{" "}
              <span
                style={{
                  fontWeight: "normal",
                  color: "#666",
                  fontSize: "0.9em",
                }}
              >
                ({group.members.length}{" "}
                {group.members.length === 1 ? "member" : "members"})
              </span>
            </h3>

            <div className="employee-card-grid">
              {group.members.map((memberId) => {
                const emp = employees.find((e) => e.id === memberId);
                if (!emp) return null;
                return (
                  <div
                    key={emp.id}
                    className="employee-card clickable"
                    onClick={() => setSelectedEmployee(emp)}
                  >
                    <img src={emp.image} alt={emp.name} />
                    <div className="employee-info">
                      <h4>{emp.name}</h4>
                      <p>{emp.position}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {ungroupedEmployees.length > 0 && (
          <div className="group-section">
            <h3>Ungrouped</h3>
            <div className="employee-card-grid">
              {ungroupedEmployees.map((emp) => (
                <div
                  className={`employee-card ${
                    deactivatedEmployees.includes(emp.id) ? "deactivated" : ""
                  }`}
                  onClick={() => handleSelectEmployee(emp)}
                >
                  <img src={emp.image} alt={emp.name} />
                  <h4>{emp.name}</h4>
                  <p>{emp.position}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {isGroupModalOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Create New Group</h3>

            {/* Group Name Input */}
            <input
              type="text"
              placeholder="Enter group name"
              value={newGroupName}
              onChange={(e) => setNewGroupName(e.target.value)}
            />

            {/* Member Selection */}
            <div className="member-list">
              {employees.map((emp) => (
                <label key={emp.id} className="member-item">
                  <input
                    type="checkbox"
                    checked={selectedMembers.includes(emp.id)}
                    onChange={() => toggleMember(emp.id)}
                  />
                  <img src={emp.image} alt={emp.name} />
                  <span>{emp.name}</span>
                </label>
              ))}
            </div>

            {/* Modal Actions */}
            <div className="modal-actions">
              <button
                onClick={handleSaveGroup}
                className="save-btn"
                disabled={!newGroupName.trim() || selectedMembers.length === 0}
              >
                Save Group
              </button>

              <button
                onClick={() => {
                  setIsGroupModalOpen(false);
                  setNewGroupName("");
                  setSelectedMembers([]);
                }}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Employee Info Modal */}
      {selectedEmployee && (
        <div className="modal-overlay">
          <div className="modal employee-modal">
            <h3>Employee Information</h3>

            <div className="employee-modal-content">
              {/* ---------- PROFILE IMAGE + BASIC INFO ---------- */}
              <div className="profile-header">
                <img
                  src={selectedEmployee.image}
                  alt={selectedEmployee.firstName}
                  className="modal-avatar"
                />
                <div className="basic-info">
                  <h4>
                    {isEditing ? (
                      <>
                        <input
                          type="text"
                          value={editedEmployee.firstName}
                          onChange={(e) =>
                            setEditedEmployee({
                              ...editedEmployee,
                              firstName: e.target.value,
                            })
                          }
                          placeholder="First Name"
                        />
                        <input
                          type="text"
                          value={editedEmployee.lastName}
                          onChange={(e) =>
                            setEditedEmployee({
                              ...editedEmployee,
                              lastName: e.target.value,
                            })
                          }
                          placeholder="Last Name"
                        />
                      </>
                    ) : (
                      <>
                        {selectedEmployee.firstName} {selectedEmployee.lastName}
                      </>
                    )}
                  </h4>
                  <p>
                    <strong>Position:</strong>{" "}
                    {isEditing ? (
                      <input
                        type="text"
                        value={editedEmployee.position}
                        onChange={(e) =>
                          setEditedEmployee({
                            ...editedEmployee,
                            position: e.target.value,
                          })
                        }
                      />
                    ) : (
                      selectedEmployee.position
                    )}
                  </p>
                  <p>
                    <strong>Email:</strong>{" "}
                    {isEditing ? (
                      <input
                        type="email"
                        value={editedEmployee.email}
                        onChange={(e) =>
                          setEditedEmployee({
                            ...editedEmployee,
                            email: e.target.value,
                          })
                        }
                      />
                    ) : (
                      selectedEmployee.email
                    )}
                  </p>
                </div>
              </div>

              {/* ---------- PERSONAL INFORMATION ---------- */}
              <section className="info-section">
                <h4>Personal Information</h4>
                <div className="info-grid">
                  {[
                    "firstName",
                    "middleName",
                    "lastName",
                    "suffix",
                    "gender",
                    "dateOfBirth",
                    "contactNumber",
                    "alternateContact",
                    "civilStatus",
                  ].map((field) => (
                    <p key={field}>
                      <strong>
                        {field
                          .replace(/([A-Z])/g, " $1")
                          .replace(/^./, (str) => str.toUpperCase())}
                        :
                      </strong>{" "}
                      {isEditing ? (
                        <input
                          type="text"
                          value={editedEmployee[field] || ""}
                          onChange={(e) =>
                            setEditedEmployee({
                              ...editedEmployee,
                              [field]: e.target.value,
                            })
                          }
                        />
                      ) : (
                        selectedEmployee[field] || "—"
                      )}
                    </p>
                  ))}
                </div>
              </section>

              {/* ---------- ADDRESS ---------- */}
              <section className="info-section">
                <h4>Address</h4>
                <div className="info-grid">
                  {["address", "city", "province", "postalCode", "country"].map(
                    (field) => (
                      <p key={field}>
                        <strong>
                          {field
                            .replace(/([A-Z])/g, " $1")
                            .replace(/^./, (str) => str.toUpperCase())}
                          :
                        </strong>{" "}
                        {isEditing ? (
                          <input
                            type="text"
                            value={editedEmployee[field] || ""}
                            onChange={(e) =>
                              setEditedEmployee({
                                ...editedEmployee,
                                [field]: e.target.value,
                              })
                            }
                          />
                        ) : (
                          selectedEmployee[field] || "—"
                        )}
                      </p>
                    )
                  )}
                </div>
              </section>

              {/* ---------- EMPLOYMENT INFORMATION ---------- */}
              <section className="info-section">
                <h4>Employment Information</h4>
                <div className="info-grid">
                  {[
                    "employmentType",
                    "dateHired",
                    "regularizationDate",
                    "workLocation",
                    "shiftSchedule",
                    "reportingTo",
                  ].map((field) => (
                    <p key={field}>
                      <strong>
                        {field
                          .replace(/([A-Z])/g, " $1")
                          .replace(/^./, (str) => str.toUpperCase())}
                        :
                      </strong>{" "}
                      {isEditing ? (
                        <input
                          type="text"
                          value={editedEmployee[field] || ""}
                          onChange={(e) =>
                            setEditedEmployee({
                              ...editedEmployee,
                              [field]: e.target.value,
                            })
                          }
                        />
                      ) : (
                        selectedEmployee[field] || "—"
                      )}
                    </p>
                  ))}
                </div>
              </section>

              {/* ---------- EDUCATIONAL BACKGROUND ---------- */}
              <section className="info-section">
                <h4>Educational Background</h4>
                <div className="info-grid">
                  {[
                    "educationType",
                    "school",
                    "educationFromDate",
                    "educationToDate",
                    "educationDegree",
                  ].map((field) => (
                    <p key={field}>
                      <strong>
                        {field
                          .replace(/([A-Z])/g, " $1")
                          .replace(/^./, (str) => str.toUpperCase())}
                        :
                      </strong>{" "}
                      {isEditing ? (
                        <input
                          type="text"
                          value={editedEmployee[field] || ""}
                          onChange={(e) =>
                            setEditedEmployee({
                              ...editedEmployee,
                              [field]: e.target.value,
                            })
                          }
                        />
                      ) : (
                        selectedEmployee[field] || "—"
                      )}
                    </p>
                  ))}
                </div>
              </section>

              {/* ---------- EMERGENCY CONTACT ---------- */}
              <section className="info-section">
                <h4>Emergency Contact</h4>
                <div className="info-grid">
                  {[
                    "emergencyName",
                    "emergencyRelationship",
                    "emergencyContact",
                    "emergencyAddress",
                  ].map((field) => (
                    <p key={field}>
                      <strong>
                        {field
                          .replace(/([A-Z])/g, " $1")
                          .replace(/^./, (str) => str.toUpperCase())}
                        :
                      </strong>{" "}
                      {isEditing ? (
                        <input
                          type="text"
                          value={editedEmployee[field] || ""}
                          onChange={(e) =>
                            setEditedEmployee({
                              ...editedEmployee,
                              [field]: e.target.value,
                            })
                          }
                        />
                      ) : (
                        selectedEmployee[field] || "—"
                      )}
                    </p>
                  ))}
                </div>
              </section>
            </div>

            <div className="modal-actions">
              {isEditing ? (
                <>
                  <button onClick={handleSave} className="save-btn">
                    Save
                  </button>
                  <button
                    onClick={() => {
                      setEditedEmployee(selectedEmployee);
                      setIsEditing(false);
                    }}
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => handleEditRedirect(selectedEmployee)}
                    className="edit-btn"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => {
                      setEmployeeToToggle(selectedEmployee);
                      setConfirmModalOpen(true);
                    }}
                    className={
                      deactivatedEmployees.includes(selectedEmployee.id)
                        ? "activate-btn"
                        : "deactivate-btn"
                    }
                  >
                    {deactivatedEmployees.includes(selectedEmployee.id)
                      ? "Activate"
                      : "Deactivate"}
                  </button>

                  <button
                    onClick={() => setSelectedEmployee(null)}
                    className="close-btn"
                  >
                    Close
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {isTransitioning && (
        <div className="transition-overlay">
          <div className="spinner"></div>
        </div>
      )}
      
      {confirmModalOpen && employeeToToggle && (
        <div className="modal-overlay">
          <div className="modal confirm-modal">
            <h3>
              {deactivatedEmployees.includes(employeeToToggle.id)
                ? "Reactivate Employee"
                : "Deactivate Employee"}
            </h3>
            <p>
              Are you sure you want to{" "}
              {deactivatedEmployees.includes(employeeToToggle.id)
                ? "reactivate"
                : "deactivate"}{" "}
              <strong>
                {employeeToToggle.firstName} {employeeToToggle.lastName}
              </strong>
              ?
            </p>

            <div className="modal-actions">
              <button
                onClick={() => {
                  handleDeactivateEmployee(employeeToToggle.id);
                  setConfirmModalOpen(false);
                  setEmployeeToToggle(null);
                }}
                className={
                  deactivatedEmployees.includes(employeeToToggle.id)
                    ? "activate-btn"
                    : "deactivate-btn"
                }
              >
                {deactivatedEmployees.includes(employeeToToggle.id)
                  ? "Yes, Activate"
                  : "Yes, Deactivate"}
              </button>

              <button
                onClick={() => {
                  setConfirmModalOpen(false);
                  setEmployeeToToggle(null);
                }}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminMyTeam;
